import { render } from "./CustomerProfileView.vue?vue&type=template&id=1081961e&scoped=true&ts=true&lang=pug"
import script from "./CustomerProfileView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerProfileView.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerProfileView.vue?vue&type=style&index=0&id=1081961e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1081961e"]])

export default __exports__